import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {
  Indicatori,
  MacroView,
  Methodology,
  Steps,
  StepComponents,
  Submenu,
  ScenarioCategory,
  DefaultRunSetups,
  FilterOptions,
  Response,
  ToolTable,
  Table,
  SubtoolResponse,
  GsComponentResponse} from '../models';
import { FileConfig, Discounting, SubtoolOutputDetails, SubtoolViewByOutput, TemplateTaxonomyOutput, TemplateTaxonomyUpdateInput, ScenarioTypes, UBELScenario, CashflowPatternScenario, BestEstimateModal } from '../models/tool.model';

import { CI_Overview, ReferenceYearsList} from '../models/table.models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class ToolService {


  constructor(private http: HttpClient) { }

  async getSubmenu(idExecution: string): Promise<{ subtools: Submenu[] }> {
    return await this.http.get<{ subtools: Submenu[] }>(`${environment.apiUrl}/GetOutputSubtools`,
      {
        params: new HttpParams().set('id', idExecution)
      }
    ).toPromise();
  }

  async getViewNL(idExecution: string, subtools: string): Promise<{ macro_voci: MacroView[] }> {
    return await this.http.get<{ macro_voci: MacroView[] }>(`${environment.apiUrl}/GetViews_NonLife`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('subtool', subtools)
      }
    ).toPromise();
  }

  async getMacroViewGS(idExecution: string): Promise<{ macro_voci: MacroView[] }> {
    return await this.http.get<{ macro_voci: MacroView[] }>(`${environment.apiUrl}/GetViewsOverview_GS`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
      }
    ).toPromise();
  }

  async getFilterNL(idExecution: string, subtool: string, viewBy: string): Promise<{ filter_options: FilterOptions[] }> {
    return await this.http.get<{ filter_options: FilterOptions[] }>(`${environment.apiUrl}/GetFilter_NonLife`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('subtool', subtool)
          .set('view_by', viewBy)
      }
    ).toPromise();
  }

  // tslint:disable-next-line: max-line-length
  async getIndicatoriNL(idExecution: string, subtool: string, viewByMacro: string, viewByMicro: string): Promise<{ list_indicatori: Indicatori[] }> {
    return await this.http.get<{ list_indicatori: Indicatori[] }>(`${environment.apiUrl}/GetIndicatori_NonLife`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('subtool', subtool)
          .set('view_by_macro', viewByMacro)
          .set('view_by_micro', viewByMicro)
      }
    ).toPromise();
  }

  async getWalletList(idExecution: string, viewByMicro: string): Promise<{ lista: Indicatori[] }> {
    return await this.http.get<{ lista: Indicatori[] }>(`${environment.apiUrl}/getLista_Portafogli`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('id-modulo', viewByMicro)
      }
    ).toPromise();
  }

  // tslint:disable-next-line: max-line-length
  async getTableNL(idExecution: string, subtool: string, viewByMacro: string, viewByMicro: string, filters: string, indicators: string): Promise<ToolTable> {
    return await this.http.get<ToolTable>(`${environment.apiUrl}/GetTables_NonLife`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('subtool', subtool)
          .set('view_by_macro', viewByMacro)
          .set('view_by_micro', viewByMicro)
          .set('filter_option', filters)
          .set('indicatore', indicators)
      }
    ).toPromise();
  }

  async getMethodology(idExecution: string, idAggregation: string): Promise<{ methodologies: Methodology[] }> {
    return await this.http.get<{ methodologies: Methodology[] }>(`${environment.apiUrl}/getScenarioMethodology`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('id-agg-portfolio', idAggregation)
      }
    ).toPromise();
  }

  async getDefaultRunSetups(idExecution: string, idAggPortfolio: string): Promise<DefaultRunSetups> {
    return await this.http.get<DefaultRunSetups>(`${environment.apiUrl}/getDefaultRunSetups`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('id-agg-portfolio', idAggPortfolio)
      }
    ).toPromise();
  }

  async createScenario(idExecution: string, idPortfolio: string, name: string, type: string): Promise<{ id_scenario: string }> {
    return await this.http.post<{ id_scenario: string }>(`${environment.apiUrl}/CreateNewStandardScenario`,
      {
        id_execution: idExecution,
        id_portfolio: idPortfolio,
        name,
        methodology_type: type
      }
    ).toPromise();
  }

  async getScenarioSteps(idExecution: string, idAggregation: string, idScenario: string): Promise<{ steps: Steps[] }> {
    return await this.http.get<{ steps: Steps[] }>(`${environment.apiUrl}/getScenarioSteps`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('id-agg-portfolio', idAggregation)
          .set('id-scenario', idScenario)
      }
    ).toPromise();
  }

  // tslint:disable-next-line: max-line-length
  async getScenarioStepsComponent(idExecution: string, idAggregation: string, idScenario: string, idStep: string): Promise<{ components: StepComponents[] }> {
    return await this.http.get<{ components: StepComponents[] }>(`${environment.apiUrl}/getScenarioStepComponent`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('id-agg-portfolio', idAggregation)
          .set('id-scenario', idScenario)
          .set('id-step', idStep)
      }
    ).toPromise();
  }

  // tslint:disable-next-line: max-line-length
  async getScenarioSingleComponent(idExecution: string, idAggregation: string, idScenario: string, idStep: string, idComponent: string): Promise<any> {
    return await this.http.get<any>(`${environment.apiUrl}/LOAD_SINGLE_COMPONENT`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('id-agg-portfolio', idAggregation)
          .set('id-scenario', idScenario)
          .set('id-step', idStep)
          .set('id-component', idComponent)
      }
    ).toPromise();
  }

  // tslint:disable-next-line: max-line-length
  async editScenarioSingleComponent(idExecution: string, idAggregation: string, idScenario: string, idStep: string, idComponent: string, data: any): Promise<{ componenets_to_reload: string[] }> {
    return await this.http.post<{ componenets_to_reload: string[] }>(`${environment.apiUrl}/EDIT_SINGLE_COMPONENT`,
      {
        id_execution: idExecution,
        id_portfolio: idAggregation,
        id_scenario: idScenario,
        id_step: idStep,
        id_component: idComponent,
        updated_component: data
      }
    ).toPromise();
  }

  async editTableCompanyResult(idExecution: string, idAggregation: string, data: Table): Promise<Response> {
    return await this.http.post<Response>(`${environment.apiUrl}/EDIT_Subtool5_table`,
      {
        id_execution: idExecution,
        id_portfolio: idAggregation,
        table: data
      }
    ).toPromise();
  }

  async getPortoflioScenari(idExecution: string, idPortfolio: string): Promise<{ scenario_categories: ScenarioCategory[] }> {
    return this.http.get<{ scenario_categories: ScenarioCategory[] }>(`${environment.apiUrl}/getPortfolioScenari`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('id-agg-portfolio', idPortfolio)
      }
    ).toPromise();
  }

  async getAvailableScenarioTypes(idExecution: string): Promise<{ availableScenarioTypes: ScenarioTypes[] }> {
    return this.http.get<{ availableScenarioTypes: ScenarioTypes[] }>(`${environment.apiUrl}/getAvailableScenarioTypes`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
      }
    ).toPromise();
  }

  async getExistingScenariByMethodology(idExecution: string, idPortfolio: string): Promise<{ methodology: Methodology[] }> {
    return this.http.get<{ methodology: Methodology[] }>(`${environment.apiUrl}/getExistingScenariByMethodology`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('id-agg-portfolio', idPortfolio)
      }
    ).toPromise();
  }

  // tslint:disable-next-line: max-line-length
  async createNewDefaultRun(idExecution: string, idPortfolio: string, name: string, config: DefaultRunSetups): Promise<{ id_scenario: string }> {
    return await this.http.post<{ id_scenario: string }>(`${environment.apiUrl}/CreateNewDefaultRun`,
      {
        id_execution: idExecution,
        id_portfolio: idPortfolio,
        name,
        config
      }
    ).toPromise();
  }

  // tslint:disable-next-line: max-line-length
  async createNewAssignWeightScenario(idExecution: string, idPortfolio: string, name: string, config: { methodology: Methodology[] }): Promise<{ id_scenario: string }> {
    return await this.http.post<{ id_scenario: string }>(`${environment.apiUrl}/CreateNewAssignWeightScenario`,
      {
        id_execution: idExecution,
        id_portfolio: idPortfolio,
        name,
        config
      }
    ).toPromise();
  }

  async getBestEstimateModal(idExecution: string, idPortfolio: string) : Promise<BestEstimateModal>{
    return await this.http.get<BestEstimateModal>(`${environment.apiUrl}/GetBestEstimateModal`,
      {
        params: new HttpParams()
        .set('id-execution', idExecution)
        .set('id-agg-portfolio', idPortfolio)
      }
    ).toPromise();
  }

  async createNewBestEstimateScenario(idExecution: string, idPortfolio: string, name: string, config: { ubelScenario: UBELScenario, cashflowPatternScenario: CashflowPatternScenario }): Promise<{ id_scenario: string }> {
    return await this.http.post<{ id_scenario: string }>(`${environment.apiUrl}/CreateNewBestEstimateScenario`,
      {
        id_execution: idExecution,
        id_portfolio: idPortfolio,
        name,
        config
      }
    ).toPromise();
  }

  async deleteScenario(idExecution: string, idPortfolio: string, idSenario: string): Promise<Response> {
    return await this.http.post<Response>(`${environment.apiUrl}/DeleteScenario`,
      {
        id_execution: idExecution,
        id_portfolio: idPortfolio,
        id_scenario: idSenario
      }
    ).toPromise();
  }

  async proceedStep(idExecution: string, idPortfolio: string, idScenario: string, idCurrentStep: string): Promise<Response> {
    return await this.http.post<Response>(`${environment.apiUrl}/Subtool4_Proceed`,
      {
        id_execution: idExecution,
        id_portfolio: idPortfolio,
        id_scenario: idScenario,
        id_current_step: idCurrentStep
      }
    ).toPromise();
  }

  async getEditableComponents(idExecution: string, idPortfolio: string): Promise<ToolTable> {
    return await this.http.get<ToolTable>(`${environment.apiUrl}/getSubtool5_Editable_Componenets`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('id-agg-portfolio', idPortfolio)
      }
    ).toPromise();
  }

  async getCompanyOverviewData(idExecution: string, referenceYear?: string | undefined): Promise<SubtoolResponse> {
    return await this.http.get<SubtoolResponse>(`${environment.apiUrl}/GetSubtool1`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('referenceYear', referenceYear? referenceYear : null)
      }
    ).toPromise();
  }


  async getReferenceYearsSubtool1(idExecution: string): Promise<ReferenceYearsList> {
    return await this.http.get<ReferenceYearsList>(`${environment.apiUrl}/GetReferenceYearsSubtool1`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
      }
    ).toPromise();
  }

  async getDataQualityData(idExecution: string, allYears: boolean | undefined): Promise<GsComponentResponse> {
    return await this.http.get<GsComponentResponse>(`${environment.apiUrl}/GetSubtoolDataQuality`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('allYears', allYears.toString())
      }
    ).toPromise();
  }

  async getReloadedComponents(idExecution: string, idPortfolio: string): Promise<SubtoolResponse> {
    return await this.http.get<SubtoolResponse>(`${environment.apiUrl}/getSubtool5_Reloaded_Componenets`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('id-agg-portfolio', idPortfolio)
      }
    ).toPromise();
  }

  async getCompanyResTotalViewData(idExecution: string, viewByMicro: string): Promise<SubtoolResponse> {
    return await this.http.get<SubtoolResponse>(`${environment.apiUrl}/getSubtool5_TotalView_Componenets`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('id-modulo', viewByMicro)
      }
    ).toPromise();
  }

  async getResultComparisonData(idExecution: string, viewByMicro: string): Promise<SubtoolResponse> {
    return await this.http.get<SubtoolResponse>(`${environment.apiUrl}/getSubtool6_Components`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('view_by', viewByMicro)
      }
    ).toPromise();
  }

  async getGSList(idExecution: string): Promise<{ list_gestioni_separate: Indicatori[] }> {
    return await this.http.get<{ list_gestioni_separate: Indicatori[] }>(`${environment.apiUrl}/GetGestioniSeparate_List`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
      }
    ).toPromise();
  }

  async getGSFilter(idExecution: string, subtool: string, view?: string): Promise<{ filter_options: FilterOptions[] }> {
    return await this.http.get<{ filter_options: FilterOptions[] }>(`${environment.apiUrl}/GetFilter_GS`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('subtool', subtool)
          .set('view', view)
      }
    ).toPromise();
  }

  // tslint:disable-next-line: max-line-length
  async getGSTable(idExecution: string, idGestione: string, startDate: string, evaluationDate: string, soglia: string, filterCategorieOptions: string[]): Promise<GsComponentResponse> {
    return await this.http.post<GsComponentResponse>(`${environment.apiUrl}/GetRendiconto_GS`,
      {
        id_execution: idExecution,
        id_gestione: idGestione,
        data_inizio: startDate,
        data_valutazione: evaluationDate,
        soglia,
        filter_categorie_options: filterCategorieOptions
      }
    ).toPromise();
  }

  async getBilancioGSTable(idExecution: string, startDate: string, evaluationDate: string, soglia: string,filterCategorieOptions: string[]): Promise<GsComponentResponse> {
    return await this.http.post<GsComponentResponse>(`${environment.apiUrl}/GetBilancio_GS`,
      {
        id_execution: idExecution,
        data_inizio: startDate,
        data_valutazione: evaluationDate,
        soglia,
        filter_categorie_options: filterCategorieOptions
      }
    ).toPromise();
  }
  async getOverviewComponentList(idExecution: string, view: string): Promise<{list_indicatori: Indicatori[]}> {
    return await this.http.get<{list_indicatori: Indicatori[]}>(`${environment.apiUrl}/GetOverviewComponentsList_GS`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('view', view)
      }
    ).toPromise();
  }

  async getComposizioneList(idExecution: string): Promise<{values: ScenarioCategory[]}> {
    return await this.http.get<{values: ScenarioCategory[]}>(`${environment.apiUrl}/GetComposizioneList_GS`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
      }
    ).toPromise();
  }

  // tslint:disable-next-line: max-line-length
  async getOverviewComponent(view: string, idExecution: string, componentName: string, filter?: string, filterType?: string): Promise<StepComponents> {
    return await this.http.get<StepComponents>(`${environment.apiUrl}/GetOverviewComponent_GS`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('view', view)
          .set('component-name', componentName)
          .set('filter', filter)
          .set('filter-type', filterType)
      }
    ).toPromise();
  }

  async getMacroViewCI(idExecution: string ): Promise<{ data: MacroView[] }> {
    return await this.http.get<{ data: MacroView[] }>(`${environment.apiUrl}/GetViewsOverview_CI`,
    {
        params: new HttpParams()
            .set('id-execution', idExecution)
    }
    ).toPromise();
  }

  async getCompanyOverviewCI(idExecution: string): Promise<CI_Overview> {
    return await this.http.get<CI_Overview>(`${environment.apiUrl}/GetOverview_CI`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
      }
    ).toPromise();
  }

  async getMovimentazioneFilterData(idExecution: string, searchInput: string): Promise<{hints: string[]}> {
    return await this.http.get<{hints: string[]}>(`${environment.apiUrl}/GetIsinHint_GS`,
      {
        params: new HttpParams()
          .set('id-execution', idExecution)
          .set('search_input', searchInput)
      }
    ).toPromise();
  }

  async getPowerBiToken(idExecution: string): Promise<{token: string, report_id: string}> {
    return await this.http.get<{token: string, report_id: string}>(`${environment.apiUrl}/GetPowerBIToken`,
      {
        params: new HttpParams()
          .set('id_execution', idExecution)
      }
    ).toPromise();
  }

  async getDiscountingInfo(idExecution: string): Promise<FileConfig[]> {
    return await this.http.get<FileConfig[]>(`${environment.apiUrl}/GetDiscountingConfig`,
      {
        params: new HttpParams()
          .set('id_execution', idExecution),
      }
    ).toPromise();
  }

  async updateDiscountingConfig(discounting: Discounting): Promise<Response> {
    return await this.http.post<Response>(`${environment.apiUrl}/UpdateDiscountingConfig`,
      discounting
    ).toPromise();
  }

  async renameSubtool4Item(idExecution: string, idSenario: string, newName: string): Promise<Response> {
    return await this.http.post<Response>(`${environment.apiUrl}/Subtool4_RenameScenario`,
      {
        id_execution: idExecution,
        id_scenario: idSenario,
        new_name: newName
      }
    ).toPromise();
  }

  getAvailableOutputSubtools(idExecution: string): Promise<{ availableSubtools: string[] }> {
    return this.http.get<{ availableSubtools: string[] }>(`${environment.apiUrl}/GetAvailableOutputSubtools`,
      {
        params: new HttpParams()
          .set('id_execution', idExecution),
      }
    ).toPromise();
  }

  // tslint:disable-next-line: max-line-length
  getAvailableOutputSubtoolsDetails(idExecution: string, availableSubtools: string[]): Promise<SubtoolOutputDetails[]> {
    return this.http.post<SubtoolOutputDetails[]>(`${environment.apiUrl}/GetAvailableOutputSubtoolsDetails`,
      {
        id_execution: idExecution,
        availableSubtools
      }
    ).toPromise();
  }

  // tslint:disable-next-line: max-line-length
  getAvailableOutputSubtoolAggregationScenarios(idExecution: string, subtool: string, aggregation: string): Promise<{scenarios: SubtoolViewByOutput[]}> {
    return this.http.post<{scenarios: SubtoolViewByOutput[]}>(`${environment.apiUrl}/GetAvailableOutputSubtoolAggregationScenarios`,
      {
        id_execution: idExecution,
        subtool,
        aggregation
      }
    ).toPromise();
  }

  getAvailableCustomReportFiles(idExecution: string): Promise< string[] > {
    return this.http.get< string[] >(`${environment.apiUrl}/GetAvailableCustomReportFiles`,
      {
        params: new HttpParams()
          .set('id_execution', idExecution),
      }
    ).toPromise();
  }

  getAvailableInputFiles(idExecution: string): Promise< string[] > {
    return this.http.get< string[] >(`${environment.apiUrl}/GetAvailableInputFiles`,
      {
        params: new HttpParams()
          .set('id_execution', idExecution),
      }
    ).toPromise();
  }
  
  


    getTemplateTaxonomy(idExecution: string): Observable<TemplateTaxonomyOutput> {
        return this.http.get<TemplateTaxonomyOutput>(`${environment.apiUrl}/GetTemplateTaxonomy`,
            {params: new HttpParams()
                .set('id_execution', idExecution)              
            }
        );
    }


    async updateTemplateTaxonomy(template_configuration: TemplateTaxonomyUpdateInput): Promise<Response> {
        return await this.http.post<Response>(`${environment.apiUrl}/UpdateTemplateTaxonomy`,
            template_configuration
        ).toPromise();
    }


  





  getInputFiles(idExecution: string, inputFiles: string[]): Observable<HttpEvent<Blob>> {

    return  this.http.post(`${environment.apiUrl}/GetInputFiles`,
                                {
                                  id_execution: idExecution,
                                  input_files: inputFiles
                                }, { reportProgress:true, observe: 'events', responseType:'blob'});
   
  
  }

  getTemplateFile(idExecution: string, idTemplate: string): Observable<HttpEvent<Blob>> {

    return  this.http.post(`${environment.apiUrl}/GetTemplateFile`,
                                {
                                  id_execution: idExecution,
                                  template_id: idTemplate
                                }, { reportProgress:true, observe: 'events', responseType:'blob'});
   
  
  }


 

   getOutputFiles(idExecution: string, outputFiles: SubtoolOutputDetails[]):  Observable<HttpEvent<Blob>>{

    return  this.http.post(`${environment.apiUrl}/GetOutputFiles`,
                                {
                                  id_execution: idExecution,
                                  availableSubtoolsDetails: outputFiles
                                }, { reportProgress:true, observe: 'events', responseType: 'blob'});
    
  }

  getOutputFilesOPV(id_lotto: number):  Observable<HttpEvent<Blob>>{

    return  this.http.post(`${environment.apiUrl}/GetOutputFiles_OPV`,
                                {
                                  id_lotto: id_lotto,
                                }, { reportProgress:true, observe: 'events', responseType: 'blob'});
    
  }

  getOutputFilesNEWRO():  Observable<HttpEvent<Blob>>{
    return  this.http.post(`${environment.apiUrl}/NEWRO/GetOutputFiles`, {}, 
      { reportProgress:true, observe: 'events', responseType: 'blob'});
  }
  
   getCustomReportFiles(idExecution: string, customReportFiles: string[]): Observable<HttpEvent<Blob>> {

    return  this.http.post(`${environment.apiUrl}/GetCustomReportFiles`,
                                          {
                                            id_execution: idExecution,
                                            input_files: customReportFiles
                                          }, { reportProgress:true, observe: 'events', responseType: 'blob'});

    
    }


}